module.exports = __webpack_public_path__ + "static/media/location_icon.eaea407c.svg";